export default [
  {
    id: 'wechat',
    title: '微信端',
    code: 'https://www.esign.cn/upload/resources/image/2020/09/10/29066.png?1651743977350',
    desc: '使用微信扫一扫',
  },
  {
    id: 'alipay',
    title: '支付宝',
    code: 'https://www.esign.cn/upload/resources/image/2020/09/10/29072.png?1651743977354',
    desc: '使用支付宝扫一扫',
  },
  {
    id: 'ios',
    title: 'IOS版',
    code: 'https://www.esign.cn/upload/resources/image/2021/12/27/32251.png?1651743977358',
    desc: '扫一扫下载IOS客户端',
  },
  {
    id: 'android',
    title: '安卓版',
    code: 'https://www.esign.cn/upload/resources/image/2022/04/28/32543.png?1651743977362',
    desc: '扫一扫下载安卓客户端',
  },
  {
    id: 'dingtalk',
    title: '钉钉端',
    code: 'https://www.esign.cn/upload/resources/image/2020/09/10/29075.png?1651743977366',
    desc: '使用钉钉扫一扫',
  },
  {
    id: 'client',
    title: '客户端',
    code: 'https://www.esign.cn/upload/resources/image/2021/09/24/31942.png?1651743977369',
    desc: '点击打开客户端下载页',
    link: 'https://www.esign.cn/gw/khdxzy/',
  },
]
